import { View } from "binder"
import { FontStyleCombo, FontStyleEditorViewModel } from "./fontStyleEditor-viewModel"

export class FontStyleEditorView extends View<FontStyleEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-E7E9BA0B-F40A-4C1A-8FA6-EA2BFD6BE821"
    }
    loadHtml(): string {
        let element = require('./fontStyleEditor.html').default;
        let style = require('./fontStyleEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set fontStyleSelector(v: FontStyleCombo) { this._fontStyleSelector = v; } public get fontStyleSelector(): FontStyleCombo { return this._fontStyleSelector;} private _fontStyleSelector: FontStyleCombo;
}
